import { useQuery } from "react-query";
import axios from "axios";
import _ from "underscore";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const getData = async () => {
  const { data } = await axios.get(
    `${apiSitePrefix}/companies/fuelsupplierscombo/`
  );
  return data;
};

export default function useFuelSuppliersCombo() {  
  
  return useQuery(
    ["combos", "fuel_suppliers"], 
    () => getData()
  );
}